import { render, staticRenderFns } from "./OnlineStatistics.vue?vue&type=template&id=3741e48a&scoped=true&"
import script from "./OnlineStatistics.vue?vue&type=script&lang=js&"
export * from "./OnlineStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStatistics.vue?vue&type=style&index=0&id=3741e48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741e48a",
  null
  
)

export default component.exports